/*
 * THEORIC — CELEBRE10 automatico para primeira compra
 *
 * Sinais, em ordem de confiabilidade:
 * 1. customer.orders_count, quando a cliente esta logada;
 * 2. marcador funcional gravado depois de checkout_completed;
 * 3. ausencia de marcador para visitantes (melhor esforco, nao antifraude).
 *
 * Nunca contem dados de pedidos ou identificadores pessoais. Os cookies de
 * influenciadoras servem somente para preservar a prioridade do cupom delas.
 */
(function () {
  'use strict';

  if (window.TheoricFirstPurchaseDiscount) return;

  var CONFIG_ID = 'theoric-first-purchase-discount-config';
  var PURCHASE_KEY = 'theoric_has_purchased';
  var AUTO_APPLIED_KEY = 'theoric_first_purchase_discount_applied';
  var SHARED_APPLIED_KEY = 'theoric_discount_applied';
  var PURCHASE_MAX_AGE = 34560000; // 400 dias: limite pratico dos navegadores.

  function normalizarCodigo(valor) {
    return String(valor || '').trim().toUpperCase();
  }

  function lerCookie(nome) {
    var prefixo = nome + '=';
    var partes = String(document.cookie || '').split(';');
    for (var i = 0; i < partes.length; i += 1) {
      var parte = partes[i].replace(/^\s+/, '');
      if (parte.indexOf(prefixo) === 0) {
        try {
          return decodeURIComponent(parte.substring(prefixo.length));
        } catch (e) {
          return parte.substring(prefixo.length);
        }
      }
    }
    return '';
  }

  function lerStorage(storage, chave) {
    try {
      return storage && storage.getItem(chave) || '';
    } catch (e) {
      return '';
    }
  }

  function escreverStorage(storage, chave, valor) {
    try {
      if (storage) storage.setItem(chave, valor);
    } catch (e) { /* navegador bloqueou storage; o cookie ainda e tentado */ }
  }

  function marcarCompraConcluida() {
    document.cookie = PURCHASE_KEY + '=1; Max-Age=' + PURCHASE_MAX_AGE +
      '; Path=/; SameSite=Lax; Secure';
    escreverStorage(window.localStorage, PURCHASE_KEY, '1');
  }

  function temMarcadorDeCompra() {
    return lerCookie(PURCHASE_KEY) === '1' ||
      lerStorage(window.localStorage, PURCHASE_KEY) === '1';
  }

  /*
   * Sinal compartilhado com outras campanhas de primeira compra.
   *
   * Cliente logada: customer.orders_count e autoritativo e vence o marcador
   * local. Visitante: a ausencia do marcador e apenas melhor esforco; nao e uma
   * garantia antifraude, mas impede a repeticao no mesmo navegador conhecido.
   */
  function candidataPrimeiraCompra(config) {
    config = config || lerConfiguracao();
    if (!config) return false;

    if (config.loggedIn) {
      return Number(config.ordersCount || 0) === 0;
    }

    return !temMarcadorDeCompra();
  }

  function lerConfiguracao() {
    var elemento = document.getElementById(CONFIG_ID);
    if (!elemento) return null;
    try {
      return JSON.parse(elemento.textContent || '{}');
    } catch (e) {
      console.warn('[CELEBRE10] configuracao invalida.', e);
      return null;
    }
  }

  function campanhaAtiva(config, agora) {
    if (config.enabled === false) return false;
    var inicio = config.startsAt ? new Date(config.startsAt).getTime() : null;
    var fim = config.endsAt ? new Date(config.endsAt).getTime() : null;
    if (inicio != null && (!isFinite(inicio) || agora < inicio)) return false;
    if (fim != null && (!isFinite(fim) || agora >= fim)) return false;
    return true;
  }

  function previewDaMeiaNoiteAtivo() {
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get('celebre10_preview') !== '1') return false;

      var hostLocal = url.hostname === '127.0.0.1' || url.hostname === 'localhost';
      var temaPreview = url.searchParams.has('preview_theme_id');
      var editor = !!(window.Shopify && window.Shopify.designMode);
      return hostLocal || temaPreview || editor;
    } catch (e) {
      return false;
    }
  }

  function cupomSolicitadoNaUrl() {
    try {
      var url = new URL(window.location.href);
      return normalizarCodigo(
        url.searchParams.get('coupon') || url.searchParams.get('ref')
      );
    } catch (e) {
      return '';
    }
  }

  function cupomDeInfluenciadora() {
    var cookie = lerCookie('ymp_coupon') || lerCookie('theoric_coupon');
    if (cookie) return normalizarCodigo(cookie);

    try {
      var salvo = JSON.parse(lerStorage(window.localStorage, 'theoric_influencer') || '{}');
      if (salvo.expires && Date.now() > Number(salvo.expires)) return '';
      return normalizarCodigo(salvo.coupon || salvo.code);
    } catch (e) {
      return '';
    }
  }

  function cuponsDoCarrinho(carrinho) {
    var aplicacoes = carrinho && carrinho.cart_level_discount_applications || [];
    return aplicacoes.map(function (item) {
      var desconto = item.discount_application || item;
      return desconto && desconto.type === 'discount_code'
        ? normalizarCodigo(desconto.title)
        : '';
    }).filter(Boolean);
  }

  function avaliar(contexto) {
    var codigo = normalizarCodigo(contexto.code);
    if (!codigo) return { eligible: false, reason: 'missing_code' };
    if (!contexto.campaignActive) return { eligible: false, reason: 'inactive_campaign' };

    if (contexto.loggedIn) {
      if (Number(contexto.ordersCount || 0) > 0) {
        return { eligible: false, reason: 'logged_in_returning_customer' };
      }
    } else if (contexto.purchaseMarked) {
      return { eligible: false, reason: 'browser_has_purchase' };
    }

    var prioridades = [
      contexto.requestedCoupon,
      contexto.influencerCoupon,
      contexto.cartCoupon
    ].map(normalizarCodigo).filter(Boolean);

    for (var i = 0; i < prioridades.length; i += 1) {
      if (prioridades[i] !== codigo) {
        return { eligible: false, reason: 'priority_coupon', coupon: prioridades[i] };
      }
    }

    var automatico = normalizarCodigo(contexto.autoAppliedCoupon);
    var compartilhado = normalizarCodigo(contexto.sharedAppliedCoupon);
    if (automatico === codigo || compartilhado === codigo || prioridades.indexOf(codigo) !== -1) {
      return { eligible: false, reason: 'already_applied' };
    }
    if (automatico || compartilhado) {
      return {
        eligible: false,
        reason: 'priority_coupon',
        coupon: automatico || compartilhado
      };
    }

    return { eligible: true, reason: 'eligible_first_purchase' };
  }

  function emitir(resultado) {
    try {
      window.dispatchEvent(new CustomEvent('theoric:first-purchase-discount', {
        detail: resultado
      }));
    } catch (e) { /* navegadores antigos nao impedem a promocao */ }
  }

  function aplicar(config) {
    var codigo = normalizarCodigo(config.code);
    return fetch('/discount/' + encodeURIComponent(codigo) + '?redirect=/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (resposta) {
      if (!resposta.ok) throw new Error('HTTP ' + resposta.status);
      return resposta.json().catch(function () { return null; });
    }).then(function (carrinho) {
      // Com itens no carrinho, um HTTP 200 nao basta: codigo invalido tambem
      // pode ser ignorado silenciosamente pela Shopify.
      if (carrinho && carrinho.item_count > 0 &&
          cuponsDoCarrinho(carrinho).indexOf(codigo) === -1) {
        throw new Error('discount_not_applied');
      }

      escreverStorage(window.sessionStorage, AUTO_APPLIED_KEY, codigo);
      emitir({ applied: true, code: codigo, reason: 'eligible_first_purchase' });
      return { applied: true, code: codigo };
    });
  }

  function iniciar() {
    var fase = document.documentElement && document.documentElement.getAttribute('data-fase');
    if (fase === 'f1' || fase === 'f2') return Promise.resolve({applied:false, reason:'black_non_cumulative'});
    var config = lerConfiguracao();
    if (!config || !config.code || typeof fetch !== 'function') return Promise.resolve(null);

    // Uma cliente logada com pedidos anteriores atualiza o navegador atual.
    if (config.loggedIn && Number(config.ordersCount || 0) > 0) {
      marcarCompraConcluida();
    }

    var previewAtivo = previewDaMeiaNoiteAtivo();
    var agora = previewAtivo && config.startsAt
      ? new Date(config.startsAt).getTime() + 1
      : Date.now();
    var ativo = campanhaAtiva(config, agora);
    var preAvaliacao = avaliar({
      code: config.code,
      campaignActive: ativo,
      loggedIn: !!config.loggedIn,
      ordersCount: config.ordersCount,
      purchaseMarked: temMarcadorDeCompra(),
      requestedCoupon: cupomSolicitadoNaUrl(),
      influencerCoupon: cupomDeInfluenciadora(),
      cartCoupon: '',
      autoAppliedCoupon: lerStorage(window.sessionStorage, AUTO_APPLIED_KEY),
      sharedAppliedCoupon: lerStorage(window.sessionStorage, SHARED_APPLIED_KEY)
    });

    if (!preAvaliacao.eligible) {
      emitir({ applied: false, code: normalizarCodigo(config.code), reason: preAvaliacao.reason });
      return Promise.resolve(preAvaliacao);
    }

    // Verifica um cupom ja aplicado diretamente no carrinho antes de sobrescrever.
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (resposta) {
        if (!resposta.ok) throw new Error('cart_unavailable');
        return resposta.json();
      })
      .then(function (carrinho) {
        var existentes = cuponsDoCarrinho(carrinho);
        var decisao = avaliar({
          code: config.code,
          campaignActive: ativo,
          loggedIn: !!config.loggedIn,
          ordersCount: config.ordersCount,
          purchaseMarked: temMarcadorDeCompra(),
          requestedCoupon: cupomSolicitadoNaUrl(),
          influencerCoupon: cupomDeInfluenciadora(),
          cartCoupon: existentes[0] || '',
          autoAppliedCoupon: lerStorage(window.sessionStorage, AUTO_APPLIED_KEY),
          sharedAppliedCoupon: lerStorage(window.sessionStorage, SHARED_APPLIED_KEY)
        });

        if (!decisao.eligible) {
          emitir({ applied: false, code: normalizarCodigo(config.code), reason: decisao.reason });
          return decisao;
        }
        return aplicar(config);
      })
      .catch(function (erro) {
        console.warn('[CELEBRE10] nao foi possivel ativar o cupom.', erro);
        var motivo = erro && erro.message === 'cart_unavailable'
          ? 'cart_unavailable'
          : 'apply_failed';
        emitir({ applied: false, code: normalizarCodigo(config.code), reason: motivo });
        return { applied: false, reason: motivo };
      });
  }

  window.TheoricFirstPurchaseDiscount = {
    evaluate: avaliar,
    init: iniciar,
    markPurchased: marcarCompraConcluida,
    hasPurchasedMarker: temMarcadorDeCompra,
    isFirstPurchaseCandidate: candidataPrimeiraCompra,
    isPreviewActive: previewDaMeiaNoiteAtivo
  };

  if (!window.__THEORIC_FIRST_PURCHASE_TEST__) iniciar();
})();
